import React, { useState, useEffect } from "react";
import { FaArrowUpLong } from "react-icons/fa6";

export default function ButtonOnTop() {
  const [isVisible, setIsVisible] = useState(false);
  const [lastScrollY, setLastScrollY] = useState(0);

  const handleScroll = () => {
    const scrollTop = window.scrollY;

    if (scrollTop > 100 && scrollTop > lastScrollY) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }

    setLastScrollY(scrollTop);
  };

  const handleScrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [lastScrollY]);

  return (
    <div className="relative z-30">
      {isVisible && (
        <button
          onClick={handleScrollToTop}
          className="fixed bottom-24 right-7 text-[#053CC8] hover:bg-slate-200 bg-white h-10 w-10 z-30 flex items-center justify-center rounded-full shadow-lg border-2 border-[#053CC8]"
        >
          <FaArrowUpLong />
        </button>
      )}
    </div>
  );
}
